import discardPile from '@/store/modules/sessionState/domSizing/discardPile';
import melds from '@/store/modules/sessionState/domSizing/melds';
import selfHand from '@/store/modules/sessionState/domSizing/selfHand';
import viewport from '@/store/modules/sessionState/domSizing/viewport';

export default {
    discardPile,
    melds,
    selfHand,
    viewport,
};
